export default "__VITE_PUBLIC_ASSET__7f5b9d2c__"